import { supPaths } from "@app/routing/supPaths";
import { useBreadcrumb } from "@app/shared/components/Breadcrumb/useBreadcrumb";
import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useSupplierQuestionnaire } from "./data";

export function useQuestionnaireBreadcrumb() {
    const { questionnaire_id, sup_id } = useParams();
    const { questionnaire: currentQuestionnaire } = useSupplierQuestionnaire(
        questionnaire_id,
        sup_id,
    );

    const breadcrumbArgs = useMemo(() => {
        return [
            supPaths.questionnaire_id_param,
            currentQuestionnaire?.name ?? "...",
        ] as const;
    }, [questionnaire_id, currentQuestionnaire]);

    const setBreadcumb = useBreadcrumb();

    useEffect(() => {
        const [path, name] = breadcrumbArgs;
        setBreadcumb(path, name);
        setBreadcumb(supPaths.questionnaires, "Questionnaires");
    }, [breadcrumbArgs]);
}
